import React from "react";
import NetworkForm from "../form/index";

const AddNetwork = () => {
  return <NetworkForm title="Adicionar rede" network={false} />;
};

export default AddNetwork;
